<template>
  <!-- Start Footer Area -->
  <footer class="footer-area bg-f7fafd">
    <div class="container">
      <div class="row">
        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <div class="logo">
              <a href="/">
                <img src="../../assets/img/logo.png" alt="logo" />
              </a>
            </div>
            <p>&nbsp;</p>
          </div>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-5">&nbsp;</div>
          <p>
            At
            <span class="primary">Interactive</span>, we hire people who make things happen. We are currently seeking the next generation of software developers and network innovators, people with the talent, passion,
            and pride to take technology to the next level.
          </p>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget pl-5">&nbsp;</div>
          <p>
            Are you ready?
            <br />
            <br />Submit your resume to:
            <a
              href="mailto:resumes@interactivedev.com"
            >resumes@interactivedev.com</a>
          </p>
        </div>

        <div class="col-lg-3 col-md-6 col-sm-6">
          <div class="single-footer-widget">
            <h3>Address</h3>

            <ul class="footer-contact-info">
              <li>
                <feather type="map-pin"></feather>824 Elmwood Park Blvd.
                <br />Suite 290
                <br />Harahan, LA 70123, USA
              </li>
              <li>
                <feather type="mail"></feather>Email:
                <a href="mailto:info@interactivedev.com">info@interactivedev.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-lg-12 col-md-12">
          <div class="copyright-area">
            <p>Copyright &copy;{{ new Date().getFullYear() }} Interactive. All Rights Reserved</p>
          </div>
        </div>
      </div>
    </div>

    <img src="../../assets/img/map.png" class="map" alt="map" />

    <back-to-top bottom="50px" right="50px">
      <div class="go-top">
        <feather type="arrow-up"></feather>
      </div>
    </back-to-top>
  </footer>
  <!-- End Footer Area -->
</template>

<script>
import BackToTop from "vue-backtotop";
export default {
  name: "Footer",
  components: { BackToTop }
};
</script>